import { render, staticRenderFns } from "./ConfirmUserResetEmail.vue?vue&type=template&id=298d5521"
import script from "./ConfirmUserResetEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmUserResetEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports